import {
  ReadonlyRepositoryCollectionService,
  RepositoryCollectionServiceOptions
} from './readonly-repository-collection.service';
import { computed } from '@angular/core';
import { ReadonlyCollectionRepository } from '../../repositories/abstraction';

export abstract class ReadonlyRepositoryCollectionSumService<T extends object, TSum, TResult, TLoadParams> extends ReadonlyRepositoryCollectionService<T, TResult, TLoadParams> {

  sum = computed(() => {
    return this.getSum(this._resource.value());
  })

  protected constructor(repository: ReadonlyCollectionRepository<TResult, TLoadParams>,
                        options?: RepositoryCollectionServiceOptions<T>) {
    super(repository, options);
  }

  abstract getSum(result: TResult | null | undefined): TSum;
}
